import { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { SecondaryButton } from '../../buttons/secondary/secondary-button';
import { useStepperCardContext } from '../provider/stepper-card.provider';
import { useStepperContext } from '../provider/stepper.provider';

const previousButtonStyle = css`
  margin-left: ${theme.spacing(2)};
`;

export type StepperPreviousButtonProps = {
  onClick?: () => void;
  trackingId?: string;
  children: ReactNode | string;
  className?: string;
};

export const StepperPreviousButton = ({
  onClick,
  trackingId = '',
  children = 'Previous',
  className,
  ...rest
}: Partial<StepperPreviousButtonProps>) => {
  const { previousFunction } = useStepperContext();
  const { step } = useStepperCardContext();

  const previous = () => {
    onClick?.();
    previousFunction?.(step);
  };

  return (
    <>
      {step !== 1 && (
        <SecondaryButton
          className={cx('step-button previous-step-button', previousButtonStyle, className)}
          trackingId={trackingId}
          onClick={previous}
          {...rest}
        >
          {children}
        </SecondaryButton>
      )}
    </>
  );
};
